<main class="col-xl-6 col-md-10 col-sm-12">
    <h3>
        404 - Pagina não encontrada!
    </h3>
    <br>
    <section>
        Você tentou acessar uma pagina que não existe, caso o erro persista entre em contato com o DPTI.
    </section>
    <br>
    <button class="btn btn-primary" (click)="redirect()">
        Voltar para o inicio
    </button>
</main>
